// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { initializeAuth, browserLocalPersistence, indexedDBLocalPersistence, signInAnonymously } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional`
const firebaseConfig = {
    apiKey: "AIzaSyDNvbl0zbiS2oYBRgZd_pW3PcAJPNHR1PE",
    authDomain: "kronoku-679f4.firebaseapp.com",
    projectId: "kronoku-679f4",
    storageBucket: "kronoku-679f4.appspot.com",
    messagingSenderId: "802727513870",
    appId: "1:802727513870:web:187cbc5d378f5cb486515f",
    measurementId: "G-CKJF7DT1DQ"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
//const auth = getAuth(); //Doesn't work on iOS due to missing GAPI or something 
const auth = initializeAuth(app, { 
    persistence: [indexedDBLocalPersistence, browserLocalPersistence] 
});


// function whichAuth() {
//     let auth
//     if (Capacitor.isNativePlatform()) {
//       auth = initializeAuth(firebaseApp, {
//         persistence: indexedDBLocalPersistence
//       })
//     } else {
//       auth = getAuth()
//     }
//     return auth
//   }

//let creds : Awaited<ReturnType<typeof signInAnonymously>> | null = null;
const getFirebaseUser = async () : Promise<typeof auth.currentUser | undefined> => {
    console.log("getFirebaseUser")

    if (auth.currentUser) return auth.currentUser;
    try {
        return (await signInAnonymously(auth)).user;
    } catch (error) {
        console.warn(error);
        throw error;
        //throw error;
        // const errorCode = error.code;
        // const errorMessage = error.message;
        // console.log(errorCode, errorMessage);
    }
}

const functions = getFunctions(app, "us-central1");
if (DB_MODE === 'local'){
    console.log("Connecting to Local Functions Emulator on port: " + 5001);
    connectFunctionsEmulator(functions, "localhost", 5001);
}
      
export {
    functions,
    getFirebaseUser
}



